<template>
    <q-toolbar class="bg-gradient-primary text-white">
        <q-icon :name="icon" size="28px" class="q-mr-sm" />
        <q-toolbar-title>
            <div class="text-h6 capitalize">{{ title }}</div>
            <div class="text-caption text-white-7">{{ producto.productoDesc }}</div>
        </q-toolbar-title>

        <!-- Badge de validación -->
        <q-badge :color="res.valid ? 'positive' : 'warning'" :label="res.valid ? 'Válido' : 'Incompleto'"
            class="q-mr-md">
            <q-icon :name="res.valid ? 'check_circle' : 'error'" size="16px" class="q-ml-xs" />
        </q-badge>

        <q-btn dense flat icon="close" v-close-popup>
            <q-tooltip>Cerrar (ESC)</q-tooltip>
        </q-btn>
    </q-toolbar>
</template>

<script setup>
 const props = defineProps({
    title: {
        type: String,
        default: 'Producto'
    },
    producto: {
        type: Object,
        required: true
    },
    res: {
        type: Object,
        required: true
    },
    icon: {
        type: String,
        default: 'add_shopping_cart'
    }
 });
</script>
